import { HttpInterceptorFn, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  
  // Get token from localStorage and ensure it's properly trimmed
  const token = localStorage.getItem('auth_token')?.trim();
  
  console.log(`Auth interceptor: Processing ${req.method} request to ${req.url}`);
  
  // List of public endpoints that don't need authentication
  const publicEndpoints = [
    '/api/employees',
    '/api/company/info',
    '/api/health',
    '/api/auth/login',
    '/api/auth/token-debug'
  ];
  
  // Check if this is a public endpoint
  const isPublicEndpoint = publicEndpoints.some(endpoint => req.url.includes(endpoint));
  
  // Check if this is a multipart/form-data request (e.g. file upload)
  // Check if the body is FormData (for file uploads)
  const isFormData = req.body instanceof FormData;
  const isMultipartFormData = isFormData ||
                              req.headers.get('Content-Type')?.includes('multipart/form-data') || 
                              req.url.includes('/cv/upload') ||
                              req.url.includes('/documents/upload') ||
                              req.url.includes('/upload-cv/') ||
                              req.url.includes('/avatars') && req.method === 'POST' ||
                              req.url.includes('/upload-video');
    
  let newRequest = req;
  
  // If token exists, add it to ALL requests (even public ones, as they might still use it for filtering)
  if (token) {
    const tokenPreview = token.substring(0, 15) + '...';
    
    // For multipart/form-data requests, don't set the Content-Type header, let the browser set it
    if (isMultipartFormData) {
      newRequest = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`
        },
        withCredentials: true // Always send credentials for file uploads
      });
    } else {
      // For regular requests, only set Authorization header
      // Don't override Content-Type if it's already set
      const headers: any = {
        'Authorization': `Bearer ${token}`
      };
      
      // Only set Content-Type to JSON if it's not already set and it's not FormData
      if (!req.headers.has('Content-Type') && !(req.body instanceof FormData)) {
        headers['Content-Type'] = 'application/json';
      }
      
      newRequest = req.clone({
        setHeaders: headers,
        withCredentials: true // Always send credentials
      });
    }
    
    // Log the resulting headers for debugging
    const authHeader = newRequest.headers.get('authorization') || 
                       newRequest.headers.get('Authorization');
  
  } else if (!isPublicEndpoint) {
    // If no token and it's not a public endpoint, redirect to login
    console.warn(`Auth interceptor: Protected endpoint ${req.url} requested without token`);
    console.warn('Auth interceptor: This will likely result in 401 errors');
    
    // Redirect to login if accessing protected endpoint without token
    if (!window.location.href.includes('login')) {
      router.navigate(['/login']);
      return throwError(() => new Error('Authentication required for this endpoint'));
    }
  }
  
  // Continue with the request
  return next(newRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        console.error('Auth interceptor: 401 Unauthorized error for URL:', req.url);
        console.error('Auth interceptor: This likely means your token is invalid or expired');
        
        // Try to redirect to login page if not already there
        if (!window.location.href.includes('login')) {
          console.log('Auth interceptor: Redirecting to login page due to authentication failure');
          router.navigate(['/login']);
        }
      }
      return throwError(() => error);
    })
  );
}; 